/*!
=========================================================
* Regiform IMS Frontend - Print Store
=========================================================
* Zustand store for managing print/PDF generation status
* Tracks ongoing print operations across the application
=========================================================
*/

import { create } from "zustand";

export const usePrintStore = create((set) => ({
  // Array of ongoing print operations
  printJobs: [],

  // Add a new print job
  addPrintJob: (type, id, label) => {
    debugger;
    const jobId = `${type}-${id}-${Date.now()}`;
    set((state) => ({
      printJobs: [
        ...state.printJobs,
        {
          id: jobId,
          type, // 'grn' or 'invoice'
          documentId: id,
          label, // e.g., "GRN-001" or "INV-2024-001"
          startTime: Date.now(),
        },
      ],
    }));
    return jobId;
  },

  // Remove a print job when complete
  removePrintJob: (jobId) => {
    set((state) => ({
      printJobs: state.printJobs.filter((job) => job.id !== jobId),
    }));
  },

  // Clear all print jobs
  clearAllPrintJobs: () => {
    set({ printJobs: [] });
  },

  // Get print jobs count
  getPrintJobsCount: () => {
    return usePrintStore.getState().printJobs.length;
  },
}));
